/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ReplyExportFormat {
    XLSX = 'XLSX',
    PDF = 'PDF'
}

export function ReplyExportFormatFromJSON(json: any): ReplyExportFormat {
    return ReplyExportFormatFromJSONTyped(json, false);
}

export function ReplyExportFormatFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplyExportFormat {
    return json as ReplyExportFormat;
}

export function ReplyExportFormatToJSON(value?: ReplyExportFormat | null): any {
    return value as any;
}

